import * as React from "react";
import {useEffect, useState} from "react";
import {Drawer} from "@mui/material";
import RedeemVoucherShowAddressCheck from "./RedeemVoucherShowAddressCheck";
import FunctionsData from "../../../Functions/FunctionsData";

/*
	Redemption of vouchers
 */
export default function RedeemVoucher({showModal,setShowModal,currentRow,setReloadOriginal}) {

    const [row, setRow] = useState([]);
    const [googlePlace, setGooglePlace] = useState([]);
    const [animal, setAnimal] = useState([]);
    const [microchips, setMicrochips] = useState([]);

    useEffect(() => {

        fetch(FunctionsData.getApiUrl('/api/orders/microchips/all'), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'token': localStorage.vTkn
            }
        })
            .then((res) => res.json())
            .then((d) => {
                let m = d.data;
                let mc = [];
                for (let x in m) {
                    mc.push(m[x]['a_microchip_number'])
                }
                setMicrochips(mc);
            });

    }, [])

    useEffect(() => {

        if (currentRow.is_redeemed > 0) {
            let x = currentRow;
            x.a_microchip_number = '';
            x.a_name = '';
            x.a_gender = '';
            x.a_age = '';
            x.a_weight = '';
            x.a_color_primary = '';
            x.a_color_secondary = '';
            x.a_surgery_amount = 0.0;
            x.a_type_surgery = '';
            x.a_is_pregnant = 0;
            x.a_was_pregnant = 0;
            x.vet_id = 0;
            x.sponsor_id = 0;
            x.sponsor_applicant_cost = 0;
            setRow(x);
        } else {
            setRow(currentRow);
            // setSurgeryTypeFn(currentRow.a_gender);
        }
    }, [currentRow]);

    if (row.length === 0) return null;
    return (
        <div>

            <Drawer
                anchor={"right"}
                open={showModal}
                size={"full"}
                onClose={() => {
                    setReloadOriginal(true);
                    setShowModal(false)
                }}
            >
                <div style={{padding: 20}}>
                    <div className={"redeem-form"}>
                        <RedeemVoucherShowAddressCheck
                            animal={animal}
                            setAnimal={setAnimal}
                            row={row}
                            setRow={setRow}
                            googlePlace={googlePlace}
                            setGooglePlace={setGooglePlace}
                            setShowModal={setShowModal}
                            setReloadOriginal={setReloadOriginal}
                            microchips={microchips}
                            open={showModal}
                            setOpen={setShowModal}
                        />
                    </div>
                </div>
            </Drawer>

        </div>
    )
}
